
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getTypeList, addWorkTime, deleteWorkTime, editWorkTime } from '@/api/workTime';

@Component({
  name: 'TemplateWorkTime',
  components: {

  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private tableData = []
  private addDescribleVisible = false
  private listLoading = false;
  private formData:any = {
    id: '',
    name: ''
  }

  created() {
    this.pagination.currentPage = 1;
    this.getTypeList();
  }

  private getTypeList() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    getTypeList(VariousTagsParam).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
      } else {
        this.tableData = [];
      }
    }).catch((err: any) => {
      let msg = err.msg;
    });
  }

  private editHandle(val:any) {
    this.addDescribleVisible = true;
    this.formData = {
      id: val.id,
      name: val.name
    };
  }
  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getTypeList();
  }
  private handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getTypeList();
  }
  private AddDescribleHandle() {
    this.addDescribleVisible = true;
    this.formData = {
      id: '',
      name: ''
    };
  }

  private SaveHandle() {
    if (!this.formData.name || this.formData.name.length > 20) {
      this.showErrorMsg('请输入工时类型,限20字');
      return;
    }
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      name: this.formData.name,
    };
    if (this.formData && this.formData.id) {
      params.id = this.formData.id;
      editWorkTime(params)
        .then((res:any) => {
          this.addDescribleVisible = false;
          this.pagination.currentPage = 1;
          this.getTypeList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    } else {
      addWorkTime(params)
        .then((res:any) => {
          this.addDescribleVisible = false;
          this.pagination.currentPage = 1;
          this.getTypeList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    }
  }

  private deleteDataHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          user_name: UserModule.getUserName,
          company_name: UserModule.getCompanyName,
          id: val.id,
        };
        deleteWorkTime(params)
          .then((res:any) => {
            this.pagination.currentPage = 1;
            this.getTypeList();
            this.showSuccessMsg(res.msg);
          })
          .catch((err) => {
            let msg = err.msg;
            this.showErrorMsg(msg);
          });
      })
      .catch(() => {
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
